import { render } from "./ExerciseWithStats.vue?vue&type=template&id=ae4e85b6&ts=true"
import script from "./ExerciseWithStats.vue?vue&type=script&lang=ts"
export * from "./ExerciseWithStats.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__